import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Navigator from "../../../Common/layouts/Navigator/Navigator";
import EditableConfigurationName from "../../../Common/components/EndPage/EditableConfigurationName/EditableConfigurationName";
import CorrespondingCountry from "../../../Retrofit/components/CorrespondingCountry/CorrespondingCountry";
import ActionLinks from "../../../Common/components/EndPage/ActionLinks/ActionLinks";
import Documentation from "../../../Common/components/EndPage/Documentation/Documentation";
import ConfigurationSaved from "../../../Common/components/EndPage/ConfigurationSaved/ConfigurationSaved";
import t from "../../../Common/utils/translation/translator";
import { setFullScreen } from "../../../Common/store/slices/common";
import {
  resetIntegratedDrives,
  selectIntegratedDrivesAxes,
  selectIntegratedDrivesConfiguration
} from "../../../IntegratedDrives/store/slices/integrated_drives";
import BillOfMaterials from "../../../Retrofit/components/BillOfMaterials/BillOfMaterials";

const IntegratedDrivesFinalize = ({ ...props }) => {
  const dispatch = useDispatch();
  const configuration = useSelector(selectIntegratedDrivesConfiguration);
  const axes = useSelector(selectIntegratedDrivesAxes);
  // get the list of motor, drive and gearbox references from axes in a single array
  const productsReferences = axes.reduce((acc, axis) => {
    const gearboxReference = axis.bundle?.gearbox?.commercialReference;
    const adaptationKitReference = axis.bundle?.adaptationKit?.commercialReference;
    if (gearboxReference) {
      acc.push(gearboxReference);
    }
    if (adaptationKitReference) {
      acc.push(adaptationKitReference);
    }
    return acc;
  }, []);

  // remove duplicates from productsReferences
  const productsReferencesUnique = [...new Set(productsReferences)];

  return (
    <>
      <div className="flex flex-row gap-5" {...props}>
        <div className="flex flex-col w-2/3 space-y-4">
          <div className="flex justify-between ">
            <EditableConfigurationName />
            {/* Here need to retrieve country from config data */}
            <CorrespondingCountry
              country={configuration.configData.country === "GB" ? "UK" : configuration.configData.country}
            />
          </div>
          <BillOfMaterials defaultSortBy="Type" />
        </div>
        <div className="flex flex-col gap-5 w-1/3 border p-2 rounded-xl shadow-md">
          <ConfigurationSaved data-testid="configuration-saved" newDesign />
          <div className="flex flex-col gap-4">
            <ActionLinks />
            <Documentation referenceIds={productsReferencesUnique} />
          </div>
        </div>
      </div>
      <Navigator
        continueLabel={t("msizer.ui.footer.go_to_start_page")}
        continueAction={() => {
          dispatch(resetIntegratedDrives());
          dispatch(setFullScreen(false));
        }}
      />
    </>
  );
};
export default IntegratedDrivesFinalize;
